import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { hitApi } from "../utils/apiCall";

import journal from "./assets/attendance.png";

import { ArrowLeft } from "lucide-react";

const AttendanceReport = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [classes, setClasses] = useState([]);
    const [sections, setSections] = useState([]);
    const [selectedClass, setSelectedClass] = useState("");
    const [selectedSection, setSelectedSection] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
const [originalReportData, setOriginalReportData] = useState([]);
const [originalAttendanceDates, setOriginalAttendanceDates] = useState([]);
    

    // --- Styles ---
    const styles = {
        container: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            backgroundColor: "#f8f9fa",
            minHeight: "100vh",
            paddingBottom: "100px",
            color: "#333",
        },
        header: {
            backgroundColor: "#ffffff",
            padding: "16px",
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #eee",
            position: "sticky",
            top: 0,
            zIndex: 10,
        },
        backBtn: {
            border: "none",
            background: "none",
            fontSize: "20px",
            marginRight: "12px",
            cursor: "pointer",
        },
        card: {
            backgroundColor: "#fff",
            borderRadius: "16px",
            padding: "20px",
            margin: "16px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        },
        tileGrid: {
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "12px",
            marginBottom: "20px",
        },
        tile: (isSelected) => ({
            padding: "16px",
            borderRadius: "12px",
            textAlign: "center",
            border: isSelected ? "2px solid #007bff" : "1px solid #eee",
            backgroundColor: isSelected ? "#e7f1ff" : "#fff",
            transition: "all 0.2s ease",
            cursor: "pointer",
        }),
        label: {
            fontSize: "12px",
            fontWeight: "700",
            color: "#888",
            textTransform: "uppercase",
            marginBottom: "8px",
            display: "block",
        },
        input: {
            width: "100%",
            padding: "14px",
            borderRadius: "10px",
            border: "1px solid #ddd",
            fontSize: "16px",
            backgroundColor: "#fdfdfd",
            marginBottom: "15px",
            boxSizing: "border-box",
        },
        fixedBottom: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "16px",
            backgroundColor: "#fff",
            borderTop: "1px solid #eee",
            boxShadow: "0 -4px 10px rgba(0,0,0,0.05)",
        },
        primaryBtn: {
            width: "100%",
            padding: "16px",
            borderRadius: "14px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            opacity: (disabled) => (disabled ? 0.6 : 1),
        },
        statusBadge: (status) => ({
            display: "inline-block",
            width: "28px",
            height: "28px",
            lineHeight: "28px",
            textAlign: "center",
            borderRadius: "50%",
            fontSize: "12px",
            fontWeight: "bold",
            backgroundColor: status === "P" ? "#28a745" : status === "A" ? "#dc3545" : "#6c757d",
            color: "#fff",
        }),
        tableWrapper: {
            overflowX: "auto",
            backgroundColor: "#fff",
            borderRadius: "12px",
        },
    };

    useEffect(() => { fetchClasses(); }, []);
    useEffect(() => { if (selectedClass) fetchSection(selectedClass); }, [selectedClass]);

    async function fetchClasses() {
        setLoading(true);
        const fd = new FormData();
        fd.append("branch[]", localStorage.getItem("branch_id") || "");
        const response = await hitApi("multiple/getMultipleDetails", "getMultipleClassDetailsOnChangeOfBranch", fd);
        if (response?.success) setClasses(response.data || []);
        setLoading(false);
    }

    async function fetchSection(classId) {
        const fd = new FormData();
        fd.append("class[]", classId);
        fd.append("branch[]", localStorage.getItem("branch_id") || "");
        const res = await hitApi("multiple/getMultipleDetails", "getMultipleSectionDetailsOnChangeOfBranch", fd);
        if (res?.success) setSections(res.data || []);
    }

async function FetchDayWiseReport(status = "") {
    setReportLoading(true);

    const fd = new FormData();

    fd.append("centerBranch", localStorage.getItem('branch_id'));
    fd.append("classId", selectedClass);
    fd.append("section", selectedSection);
    fd.append("fromDate", fromDate);
    fd.append("toDate", toDate);
    fd.append("status", status);

    const res = await hitApi(
        "reports/attedance",
        "studentAttendanceByDay",
        fd
    );

    if (res?.success) {

        // FIRST TIME LOAD
        if (status === "") {

            setOriginalReportData(res.data || []);

            // store all dates separately
            const dates = new Set();

            (res.data || []).forEach((s) => {
                if (s.attendance) {
                    Object.keys(s.attendance).forEach((d) => {
                        dates.add(d);
                    });
                }
            });

            const finalDates = Array.from(dates).sort();

            setOriginalAttendanceDates(finalDates);

            if (finalDates.length) {
                setSelectedDate(finalDates[0]);
            }
        }

        setReportData(res.data || []);
        setSelectedStatus(status);
        setStep(3);
    }

    setReportLoading(false);
}


const attendanceSummary = useMemo(() => {

    const summary = {};

    originalAttendanceDates.forEach((date) => {

        summary[date] = {
            present: 0,
            absent: 0,
            total: 0,
        };

        originalReportData.forEach((student) => {

            const status = student?.attendance?.[date];

            summary[date].total += 1;

            if (status === "P") {
                summary[date].present += 1;
            }

            if (status === "A") {
                summary[date].absent += 1;
            }
        });
    });

    return summary;

}, [originalReportData, originalAttendanceDates]);


const formatDate = (date) => {
    if (!date) return "";

    const [year, month, day] = date.split("-");

    return `${day}/${month}/${year}`;
};
    return (
        <div style={styles.container}>
            {/* HEADER */}
            <div style={styles.header}>
                <button
                    style={styles.backBtn}
                    onClick={() => {
                        if (step === 1) {
                            navigate(-1);
                        } else {
                            setStep((prev) => prev - 1);
                        }
                    }}
                >
                    <ArrowLeft size={22} />
                </button>

            </div>

            {/* STEP 1: CLASS/SECTION SELECTION */}
            {step === 1 && (
                <div style={{ padding: "10px" }}>
                    <div style={{ padding: "16px" }}>
                        <h2 style={{ marginBottom: "4px" }}>Select Class</h2>
                        <p style={{ color: "#777", marginTop: 0 }}>Tap to choose a class and section</p>
                    </div>

                    <span style={styles.label}>Classes</span>
                    <div style={styles.tileGrid}>
                        {classes.map(cls => (
                            <div
                                key={cls.key}
                                style={styles.tile(selectedClass === cls.key)}
                                onClick={() => { setSelectedClass(cls.key); setSelectedSection(""); }}
                            >
                                <div style={{ fontWeight: "bold" }}>{cls.label}</div>
                            </div>
                        ))}
                    </div>

                    {selectedClass && (
                        <>
                            <span style={styles.label}>Sections</span>
                            <div style={styles.tileGrid}>
                                {sections.map(sec => (
                                    <div
                                        key={sec.key}
                                        style={styles.tile(selectedSection === sec.key)}
                                        onClick={() => setSelectedSection(sec.key)}
                                    >
                                        <div style={{ fontWeight: "bold" }}>{sec.label}</div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    <div style={styles.fixedBottom}>
                        <button
                            style={{ ...styles.primaryBtn, opacity: (!selectedClass || !selectedSection) ? 0.6 : 1 }}
                            disabled={!selectedClass || !selectedSection}
                            onClick={() => setStep(2)}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            )}

            {/* STEP 2: DATE SELECTION */}
            {step === 2 && (
                <div style={{ padding: "10px" }}>
                    <div style={styles.card}>
                        <div style={{ textAlign: "center", marginBottom: "20px" }}>
                            <img src={journal} width="60" alt="" />
                            <h3 style={{ margin: "10px 0" }}>Date Range</h3>
                        </div>

                        <span style={styles.label}>From Date</span>
                        <input type="date" style={styles.input} value={fromDate} onChange={(e) => setFromDate(e.target.value)} />

                        <span style={styles.label}>To Date</span>
                        <input type="date" style={styles.input} value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>

                    <div style={styles.fixedBottom}>
                        <button
                            style={{ ...styles.primaryBtn, opacity: (!fromDate || !toDate || reportLoading) ? 0.6 : 1 }}
                            disabled={!fromDate || !toDate || reportLoading}
                          onClick={() => FetchDayWiseReport("")}
                        >
                            {reportLoading ? "Fetching..." : "Get Report"}
                        </button>
                    </div>
                </div>
            )}

            {/* STEP 3: REPORT VIEW */}
           {/* STEP 3: REPORT VIEW */}
{step === 3 && (
    <div style={{ padding: "10px" }}>

        {/* DATE RADIO BUTTONS */}
        <div
            style={{
                display: "flex",
                gap: "10px",
                overflowX: "auto",
                paddingBottom: "10px",
                marginBottom: "14px",
            }}
        >
            {originalAttendanceDates.map((date) => (
                <label
                    key={date}
                    style={{
                        minWidth: "fit-content",
                        padding: "10px 16px",
                        borderRadius: "999px",
                        border:
                            selectedDate === date
                                ? "2px solid #007bff"
                                : "1px solid #ddd",
                        background:
                            selectedDate === date ? "#e7f1ff" : "#fff",
                        color:
                            selectedDate === date ? "#007bff" : "#444",
                        fontWeight: "600",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        whiteSpace: "nowrap",
                    }}
                >
                    <input
                        type="radio"
                        name="attendanceDate"
                        checked={selectedDate === date}
                        onChange={() => setSelectedDate(date)}
                    />

               {formatDate(date)}
                </label>
            ))}
        </div>

        {/* SINGLE SUMMARY CARD */}
        <div
            style={{
                background: "#fff",
                borderRadius: "20px",
                padding: "18px",
                marginBottom: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "18px",
                }}
            >
                <div>
                    <div
                        style={{
                            fontSize: "13px",
                            color: "#777",
                            marginBottom: "4px",
                        }}
                    >
                        Attendance Summary
                    </div>

                    <div
                        style={{
                            fontSize: "18px",
                            fontWeight: "700",
                        }}
                    >
                  {formatDate(selectedDate)}
                    </div>
                </div>

                <div
                    style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        background: "#eef3ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        color: "#0d6efd",
                    }}
                >
                    {attendanceSummary[selectedDate]?.total || 0}
                </div>
            </div>

           <div
    style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "12px",
    }}
>
    {/* PRESENT */}
    <div
        onClick={() => FetchDayWiseReport("P")}
        style={{
            background:
                selectedStatus === "P" ? "#d7f5e3" : "#e8f7ee",
            border:
                selectedStatus === "P"
                    ? "2px solid #28a745"
                    : "2px solid transparent",
            borderRadius: "16px",
            padding: "16px",
            textAlign: "center",
            cursor: "pointer",
            transition: "0.2s",
        }}
    >
        <div
            style={{
                fontSize: "11px",
                fontWeight: "700",
                color: "#3c8c5a",
                marginBottom: "6px",
            }}
        >
            PRESENT
        </div>

        <div
            style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#28a745",
            }}
        >
            {attendanceSummary[selectedDate]?.present || 0}
        </div>
    </div>

    {/* ABSENT */}
    <div
        onClick={() => FetchDayWiseReport("A")}
        style={{
            background:
                selectedStatus === "A" ? "#ffe2e2" : "#fdecec",
            border:
                selectedStatus === "A"
                    ? "2px solid #dc3545"
                    : "2px solid transparent",
            borderRadius: "16px",
            padding: "16px",
            textAlign: "center",
            cursor: "pointer",
            transition: "0.2s",
        }}
    >
        <div
            style={{
                fontSize: "11px",
                fontWeight: "700",
                color: "#c24b4b",
                marginBottom: "6px",
            }}
        >
            ABSENT
        </div>

        <div
            style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#dc3545",
            }}
        >
            {attendanceSummary[selectedDate]?.absent || 0}
        </div>
    </div>

    {/* TOTAL */}
    <div
        onClick={() => FetchDayWiseReport("")}
        style={{
            background:
                selectedStatus === "" ? "#dfe9ff" : "#eef3ff",
            border:
                selectedStatus === ""
                    ? "2px solid #0d6efd"
                    : "2px solid transparent",
            borderRadius: "16px",
            padding: "16px",
            textAlign: "center",
            cursor: "pointer",
            transition: "0.2s",
        }}
    >
        <div
            style={{
                fontSize: "11px",
                fontWeight: "700",
                color: "#3f6ad8",
                marginBottom: "6px",
            }}
        >
            TOTAL
        </div>

        <div
            style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#0d6efd",
            }}
        >
            {attendanceSummary[selectedDate]?.total || 0}
        </div>
    </div>
</div>
        </div>

        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
            }}
        >
            <h4 style={{ margin: 0 }}>
                Results ({reportData.length})
            </h4>

         <button
    style={{
        border: "none",
        color: "#007bff",
        background: "none",
        fontWeight: "bold",
    }}
    onClick={() => {
        setSelectedStatus("");
        setReportData(originalReportData);
    }}
>
    Reset
</button>
        </div>

        {/* TABLE */}
        <div style={styles.tableWrapper}>
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                }}
            >
                <thead style={{ backgroundColor: "#f1f3f5" }}>
                    <tr>
                        <th
                            style={{
                                padding: "12px",
                                textAlign: "left",
                                fontSize: "12px",
                            }}
                        >
                            Student
                        </th>

                        <th
                            style={{
                                padding: "12px",
                                textAlign: "center",
                                fontSize: "12px",
                            }}
                        >
                            Status
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {reportData.map((student, idx) => (
                        <tr
                            key={idx}
                            style={{
                                borderBottom: "1px solid #eee",
                            }}
                        >
                            <td style={{ padding: "12px" }}>
                                <div
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                    }}
                                >
                                    {student.studentName}
                                </div>

                                <div
                                    style={{
                                        fontSize: "11px",
                                        color: "#888",
                                    }}
                                >
                                    Roll: {student.register_no}
                                </div>
                            </td>

                            <td style={{ textAlign: "center" }}>
                                <span
                                    style={styles.statusBadge(
                                        student?.attendance?.[selectedDate]
                                    )}
                                >
                                    {student?.attendance?.[selectedDate] || "-"}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
)} 
        </div>
    );
};

export default AttendanceReport;